const FoodData = [
  {
    id: 1,
    img: "https://img.freepik.com/free-photo/seafood-pizza_74190-5944.jpg?w=996&t=st=1693062328~exp=1693062928~hmac=53fd9ad496580db41c6ca8066510cd89c6b0a0389de8bb6b875a78a1eda09cb5",
    name: "Onion Pizza",
    price: 150,
    desc: "A delicious pizza topped with fresh onions for a delightful flavor combination. This pizza is perfect for onion lovers and offers a unique twist on the classic pizza experience. Enjoy the perfect blend of cheesy goodness and the sharp taste of onions in every bite. Whether you're sharing with friends or enjoying it all to yourself, this Onion Pizza is sure to satisfy your pizza cravings.",
    category: "Lunch",
    rating: 4.5,
  },
  {
    id: 2,
    img: "https://w7.pngwing.com/pngs/339/55/png-transparent-pizza-margherita-italian-cuisine-hot-dog-pizza-cheese-pizza-thumbnail.png",
    name: "Margherita Pizza",
    price: 130,
    desc: "A classic Italian pizza topped with fresh tomatoes, mozzarella cheese, basil leaves, and a drizzle of olive oil. Simple yet bursting with flavors, this Margherita Pizza is a timeless favorite that captures the essence of Italian cuisine.",
    category: "Lunch",
    rating: 4.2,
  },
  {
    id: 3,
    img: "https://w7.pngwing.com/pngs/21/55/png-transparent-pepperoni-pizza-margarita-pizza-margherita-italian-cuisine-tomato-pizza-food-cheese-recipe-thumbnail.png",
    name: "Pepperoni Pizza",
    price: 160,
    desc: "Indulge in the savory delight of this Pepperoni Pizza, loaded with slices of spicy pepperoni, melted cheese, and a tangy tomato sauce. A popular choice that's perfect for satisfying your pizza cravings.",
    category: "Lunch",
    rating: 4.6,
  },
  {
    id: 4,
    img: "https://w7.pngwing.com/pngs/569/109/png-transparent-pizza-with-vegetables-and-mushroom-toppings-sicilian-pizza-california-style-pizza-pizza-margherita-vegetarian-cuisine-pizza-food-recipe-gourmet-thumbnail.png",
    name: "Mushroom and Spinach Pizza",
    price: 140,
    desc: "Experience the earthy flavors of mushrooms combined with the freshness of spinach on this delightful pizza. Topped with a blend of cheeses, this Mushroom and Spinach Pizza offers a balanced and satisfying taste.",
    category: "Lunch",
    rating: 4.2,
  },
  {
    id: 5,
    img: "https://w7.pngwing.com/pngs/843/171/png-transparent-pizza-73-restaurant-catupiry-chicken-as-food-pizza-baked-goods-food-recipe-thumbnail.png",
    name: "BBQ Chicken Pizza",
    price: 170,
    desc: "Savor the smoky goodness of this BBQ Chicken Pizza, featuring tender pieces of chicken marinated in barbecue sauce, red onions, and a medley of cheeses. A fusion of flavors that's sure to delight your taste buds.",
    category: "Lunch",
    rating: 4.8,
  },
  {
    id: 6,
    img: "https://w7.pngwing.com/pngs/133/54/png-transparent-pancakes-served-on-plate-banana-pancakes-scrambled-eggs-breakfast-ihop-pancake-food-recipe-eating-thumbnail.png",
    name: "Classic Pancakes",
    price: 80,
    desc: "Start your day with a stack of fluffy pancakes served with maple syrup and a dollop of butter. A timeless breakfast favorite that's sure to satisfy your morning cravings.",
    category: "Breakfast",
    rating: 4.5,
  },
  {
    id: 7,
    img: "https://w7.pngwing.com/pngs/645/475/png-transparent-croissant-bread-croissant-muffin-brunch-bacon-egg-and-cheese-sandwich-bread-croissants-baked-goods-food-baking-thumbnail.png",
    name: "Egg and Bacon Croissant",
    price: 110,
    desc: "Indulge in a buttery croissant filled with scrambled eggs, crispy bacon, and melted cheese. A savory and satisfying breakfast option that's perfect for on-the-go mornings.",
    category: "Breakfast",
    rating: 4.2,
  },
  {
    id: 8,
    img: "https://w7.pngwing.com/pngs/683/103/png-transparent-frozen-yogurt-parfait-breakfast-yoghurt-fruit-salad-yogurt-frutti-di-bosco-food-breakfast-thumbnail.png",
    name: "Greek Yogurt Parfait",
    price: 95,
    desc: "Enjoy a healthy and refreshing breakfast with layers of creamy Greek yogurt, fresh berries, honey, and granola. A balanced option that provides a burst of flavors and energy.",
    category: "Breakfast",
    rating: 4.1,
  },
  {
    id: 9,
    img: "https://w7.pngwing.com/pngs/400/603/png-transparent-toast-tostytosty-la-tosteria-menu-food-dish-avocado-toast-food-toast-avocado-toast-thumbnail.png",
    name: "Avocado Toast",
    price: 120,
    desc: "Savor the creaminess of mashed avocado on toasted whole grain bread, topped with a sprinkle of sea salt and red pepper flakes. A trendy and nutritious breakfast choice.",
    category: "Breakfast",
    rating: 4.6,
  },
  {
    id: 10,
    img: "https://w7.pngwing.com/pngs/20/725/png-transparent-grain-bowl-breakfast-cereal-muesli-corn-flakes-bowl-granola-food-breakfast-recipe-thumbnail.png",
    name: "Fruit and Nut Oatmeal",
    price: 85,
    desc: "Warm up with a bowl of hearty oatmeal packed with mixed fruits, nuts, and a drizzle of honey. A wholesome breakfast that provides a satisfying start to your day.",
    category: "Breakfast",
    rating: 4.5,
  },
  {
    id: 11,
    img: "https://w7.pngwing.com/pngs/875/111/png-transparent-north-fish-seafood-dish-smoked-salmon-restaurant-grilled-fish-hd-soup-food-seafood-thumbnail.png",
    name: "Grilled Salmon",
    price: 190,
    desc: "Delight in a perfectly grilled salmon fillet seasoned with herbs and served with a side of roasted vegetables. A healthy and flavorful dinner option that's rich in omega-3 fatty acids.",
    category: "Dinner",
    rating: 4.5,
  },
  {
    id: 12,
    img: "https://w7.pngwing.com/pngs/756/828/png-transparent-taglierini-carbonara-fettuccine-alfredo-chicken-pasta-chicken-fillet-thumbnail.png",
    name: "Chicken Alfredo Pasta",
    price: 160,
    desc: "Indulge in creamy fettuccine Alfredo pasta with tender pieces of grilled chicken. This comforting dinner dish is a blend of pasta, rich Alfredo sauce, and savory chicken.",
    category: "Dinner",
    rating: 4.8,
  },
  {
    id: 13,
    img: "https://w7.pngwing.com/pngs/651/721/png-transparent-veggie-burger-vegetable-food-recipe-stir-frying-vegetables-frying-pan-frozen-vegetables-fruit-thumbnail.png",
    name: "Vegetable Stir-Fry",
    price: 130,
    desc: "Enjoy a medley of colorful vegetables stir-fried in a flavorful sauce, served over steamed rice. A light and nutritious dinner that's both satisfying and wholesome.",
    category: "Dinner",
    rating: 4.2,
  },
  {
    id: 14,
    img: "https://w7.pngwing.com/pngs/575/331/png-transparent-burrito-taco-bell-mexican-cuisine-chipotle-mexican-grill-menu-thumbnail.png",
    name: "Grilled Chicken Burrito Bowl",
    price: 160,
    desc: "Savor the flavors of a delicious burrito bowl with tender grilled chicken, black beans, rice, sautéed peppers and onions, shredded cheese, and a drizzle of zesty cilantro-lime dressing. A hearty and satisfying chicken dinner option.",
    category: "Dinner",
    rating: 4.6,
  },
  {
    id: 15,
    img: "https://w7.pngwing.com/pngs/47/171/png-transparent-chinese-noodles-hot-and-sour-soup-risotto-lomi-lamian-slippery-mushrooms-risotto-dusi-soup-food-recipe-thumbnail.png",
    name: "Mushroom Risotto",
    price: 175,
    desc: "Indulge in creamy and flavorful mushroom risotto, made with Arborio rice, sautéed mushrooms, and a touch of Parmesan cheese. A comforting and sophisticated dinner choice.",
    category: "Dinner",
    rating: 4.5,
  },
  {
    id: 16,
    img: "https://w7.pngwing.com/pngs/47/171/png-transparent-chinese-noodles-hot-and-sour-soup-risotto-lomi-lamian-slippery-mushrooms-risotto-dusi-soup-food-recipe-thumbnail.png",
    name: "Cheese and Crackers Platter",
    price: 120,
    desc: "Enjoy a variety of artisan cheeses, paired with an assortment of crispy crackers and complemented by fresh fruits and nuts. A delightful snack option for sharing or indulging in on your own.",
    category: "Snacks",
    rating: 4.3,
  },
  {
    id: 17,
    img: "https://w7.pngwing.com/pngs/204/32/png-transparent-crispy-fried-chicken-karaage-chicken-nugget-chicken-fingers-buffalo-wing-carrot-chilli-thumbnail.png",
    name: "Crispy Chicken Wings",
    price: 130,
    desc: "Savor the satisfying crunch of crispy chicken wings seasoned to perfection. Choose your favorite sauce, from tangy BBQ to spicy buffalo, for a flavorful snacking experience.",
    category: "Snacks",
    rating: 4.4,
  },
  {
    id: 18,
    img: "https://w7.pngwing.com/pngs/816/163/png-transparent-grilled-skewered-meat-bakery-paneer-tikka-indian-cuisine-vegetarian-cuisine-cake-food-baking-cake-decorating-thumbnail.png",
    name: "Paneer Tikka Skewers",
    price: 130,
    desc: "Enjoy succulent pieces of marinated paneer (Indian cottage cheese) skewered and grilled to perfection. Served with mint chutney, these paneer tikka skewers offer a flavorful and aromatic Indian snack experience.",
    category: "Snacks",
    rating: 4.9,
  },
  {
    id: 19,
    img: "https://w7.pngwing.com/pngs/356/675/png-transparent-falafel-lebanese-cuisine-take-out-mediterranean-cuisine-hummus-bed-miscellaneous-furniture-food-thumbnail.png",
    name: "Hummus and Veggie Platter",
    price: 90,
    desc: "Relish the smooth and flavorful hummus accompanied by a variety of fresh vegetable sticks and pita bread. A nutritious and satisfying option for a light and refreshing snack.",
    category: "Snacks",
    rating: 4.4,
  },
  {
    id: 20,
    img: "https://w7.pngwing.com/pngs/435/847/png-transparent-pincho-canape-skewer-fruit-others-thumbnail.png",
    name: "Fruit Skewers",
    price: 70,
    desc: "Indulge in a colorful assortment of fruit skewers featuring juicy chunks of melon, berries, pineapple, and more. A sweet and refreshing snack that's both delicious and visually appealing.",
    category: "Snacks",
    rating: 4.8,
  },
  {
    id: 21,
    img: "https://api.pizzahut.io/v1/content/en-in/in-1/images/pizza/margherita.90f9451fd66871fb6f9cf7d506053f18.1.jpg?width=550",
    name: "Margherita",
    price: 350,
    desc: "Cheese",
    category: "Pizza",
    rating: 4.3,
  },
  {
    id: 22,
    img: "https://api.pizzahut.io/v1/content/en-in/in-1/images/pizza/tandoori-paneer.4ef45717e972cf45b43c010e3cde5a22.1.jpg?width=550",
    name: "Tandoori Paneer",
    price: 70,
    desc: "Spiced paneer, Onion, Green Capsicum & Red Paprika in Tandoori Sauce",
    category: "Pizza",
    rating: 4.5,
  },
  {
    id: 23,
    img: "https://api.pizzahut.io/v1/content/en-in/in-1/images/pizza/veggie-supreme.bc8dd369182b636ff171077efa53c344.1.jpg?width=550",
    name: "Veggie Supreme",
    price: 80,
    desc: "Black Olives, Green Capsicum, Mushroom, Onion, Red Paprika, Sweet Corn",
    category: "Pizza",
    rating: 5,
  },
  {
    id: 24,
    img: "https://api.pizzahut.io/v1/content/en-in/in-1/images/pizza/double-paneer-supreme.3cb382529b41d14d4a041b5cc5e64341.1.jpg?width=550",
    name: "Double Paneer Supreme",
    price: 196,
    desc: "Spiced Paneer, Herbed Onion & Green Capsicum, Red Paprika",
    category: "Pizza",
    rating: 3,
  },
  {
    id: 25,
    img: "https://api.pizzahut.io/v1/content/en-in/in-1/images/pizza/veg-kebab-surprise.abab1dff179ab8cf95a59f30d6352297.1.jpg?width=550",
    name: "Veggie Kebab Surprise",
    price: 244,
    desc: "Veg Kebab, Onion, Green Capsicum, Tomato & Sweet Corn in Tandoori Sauce",
    category: "Pizza",
    rating: 4.0,
  },
  {
    id: 26,
    img: "https://api.pizzahut.io/v1/content/en-in/in-1/images/pizza/chicken-supreme.6d53f104f071d304a47440f2fffa7378.1.jpg?width=550",
    name: "Chicken Supreme",
    price: 75,
    desc: "Herbed Chicken, Schezwan Chicken Meatball, Chicken Tikka",
    category: "Pizza",
    rating: 4.30,
  },
  {
    id: 27,
    img: "https://api.pizzahut.io/v1/content/en-in/in-1/images/pizza/chicken-tikka-supreme.830de5a911ca95a30e4ca98e529f1b3a.1.jpg?width=550",
    name: "Chicken Tikka Supreme",
    price: 600,
    desc: "Chicken Tikka, Chicken Malai Tikka, Onion, Red Paprika",
    category: "Pizza",
    rating: 4.2,
  },
  {
    id: 28,
    img: "https://api.pizzahut.io/v1/content/en-in/in-1/images/pizza/triple-chicken-feast.e4a546e7a8581a60952b99e3fe22987e.1.jpg?width=550",
    name: "Triple Chicken Feast",
    price: 98,
    desc: "Schezwan Chicken Meatball Herbed Chicken, Chicken Sausage, Green Capsicum, Onion, Red Paprika",
    category: "Pizza",
    rating: 4.1,
  },
  {
    id: 29,
    img: "https://api.pizzahut.io/v1/content/en-in/in-1/images/pizza/chicken-tikka.6d441a65371e941db36c2754586119a8.1.jpg?width=550",
    name: "Chicken Tikka",
    price: 290,
    desc: "Chicken Tikka, Onion, Tomato",
    category: "Pizza",
    rating: 4.3,
  },
  {
    id: 30,
    img: "https://api.pizzahut.io/v1/content/en-in/in-1/images/pizza/double-chicken-sausage.f172dd6a365e90e655258b17555e74ad.1.jpg?width=550",
    name: "Double Chicken Sausage",
    price: 457,
    desc: "Chicken Sausage",
    category: "Pizza",
    rating: 4.6,
  },
  {
    id: 31,
    img: "https://api.pizzahut.io/v1/content/en-in/in-1/images/pizza/spiced-chicken-meatballs.abd238e81080106d181567a9b52844ae.1.jpg?width=550",
    name: "Spiced Chicken Meatballs",
    price: 340,
    desc: "Schezwan Chicken Meatball Onion",
    category: "Pizza",
    rating: 3.8,
  },
  {
    id: 32,
    img: "https://api.pizzahut.io/v1/content/en-in/in-1/images/pizza/double-cheese.3c8885f8bc6f18facedc7626368f5105.1.jpg?width=550",
    name: "Double Cheese",
    price: 300,
    desc: "Extra Cheese on Cheese",
    category: "Pizza",
    rating: 5,
  },
  {
    id: 33,
    img: "https://api.pizzahut.io/v1/content/en-in/in-1/images/pizza/chicken-pepper-crunch.624edb192601b73335e0100db5a6263a.1.jpg?width=550",
    name: "Chicken Pepper Crunch",
    price: 505,
    desc: "Herbed Chicken, Onion, Green Capsicum, Red Capsicum",
    category: "Pizza",
    rating: 4.1,
  },
  {
    id: 34,
    img: "https://api.pizzahut.io/v1/content/en-in/in-1/images/pizza/italian-chicken-feast.edad91a082e9a16d677722a071487a1c.1.jpg?width=550",
    name: "Italian Chicken Feast",
    price: 256,
    desc: "Herbed Chicken, Onion, Green Capsicum, Red Capsicum",
    category: "Pizza",
    rating: 4.5,
  },
  {
    id: 35,
    img: "https://api.pizzahut.io/v1/content/en-in/in-1/images/pizza/corn.f8baa08ad7f607f1de30f96bb9245b50.1.jpg?width=550",
    name: "Corn & Cheese",
    price: 245,
    desc: "Cheese, Sweet Corn",
    category: "Pizza",
    rating: 4,
  },
  {
    id: 36,
    img: "https://api.pizzahut.io/v1/content/en-in/in-1/images/pizza/tandoori-onion.98e8cbd306a1166cedbbdbd2a97eade3.1.jpg?width=550",
    name: "Tandoori Onion",
    price: 456,
    desc: "Cheese & Onion in Tandoori sauce",
    category: "Pizza",
    rating: 3.7,
  },
  {
    id: 37,
    img: "https://api.pizzahut.io/v1/content/en-in/in-1/images/pizza/chicken-pepperoni.6952ef03215b72477abff3574b4b881e.1.jpg?width=550",
    name: "Chicken Pepperoni",
    price: 517,
    desc: "Cheese, Chicken pepperoni",
    category: "Pizza",
    rating: 3.8,
  },
  {
    id: 38,
    img: "https://api.pizzahut.io/v1/content/en-in/in-1/images/pizza/chicken-n-corn-delight.61cc42effb2de18e6625796c964dd92d.1.jpg?width=550",
    name: "Chicken N Corn Delight",
    price: 290,
    desc: "Cheese, Chicken pepperoni",
    category: "Pizza",
    rating: 4.9,
  },
  {
    id: 39,
    img: "https://api.pizzahut.io/v1/content/en-in/in-1/images/pizza/farmers-pick.794695a631c14d4404057470020be703.1.jpg?width=550",
    name: "Farmers Pick",
    price: 265,
    desc: "Onion Herbed & Green Capsicum, Red Capsicum, Mushroom, Baby Corn",
    category: "Pizza",
    rating: 4.8,
  },
  {
    id: 40,
    img: "https://api.pizzahut.io/v1/content/en-in/in-1/images/pizza/classic-corn-pan-personal.7c80196383b32e2ad5715646c1b12df8.1.png?width=550",
    name: "Classic Corn",
    price: 340,
    desc: "Pizza topped with our Classic Pan sauce, sweet corn and cheesy dressing. An all-time favorite.",
    category: "Pizza",
    rating: 4.6,
  },
  {
    id: 41,
    img: "https://api.pizzahut.io/v1/content/en-in/in-1/images/pizza/classic-onion-capsicum-pan-personal.dad788ecbd3fcc57366462827e31ee05.1.jpg?width=550",
    name: "Classic Onion Capsicum",
    price: 4,
    desc: "Pizza topped with our Classic Pan sauce, crunchy onion & capsicum and cheesy dressing.",
    category: "Pizza",
    rating: 4.7,
  },
  {
    id: 42,
    img: "https://api.pizzahut.io/v1/content/en-in/in-1/images/pizza/italian-onion-tomato-pan-personal.cb37b0766ef3ba8844fa69b2d073c215.1.jpg?width=550",
    name: "Italian Onion Tomato",
    price: 8,
    desc: "Pizza topped with our Chef's Special Italian sauce, crunchy onion, juicy tomatoes and cheesy dressing.",
    category: "Pizza",
    rating: 5,
  },
  {
    id: 43,
    img: "https://api.pizzahut.io/v1/content/en-in/in-1/images/pizza/tandoori-mushroom-&-sweet-corn-pan-personal.49a1287d1cece07781c106e552979fa2.1.jpg?width=550",
    name: "Tandoori Mushroom & Sweet Corn",
    price: 5,
    desc: "Pizza topped with our signature tandoori sauce, juicy mushroom, sweet corn and cheesy dressing.",
    category: "Pizza",
    rating: 3.7,
  },
  {
    id: 44,
    img: "https://api.pizzahut.io/v1/content/en-in/in-1/images/pizza/schezwan-corn-&-capsicum-pan-personal.23c83846270110a536b40ec74529e907.1.jpg?width=550",
    name: "Schezwan Corn & Capsicum",
    price: 6,
    desc: "Pizza topped with Spicy Schezwan sauce, sweet corn & crunchy capsicum and cheesy dressing.",
    category: "Pizza",
    rating: 3.8,
  },
  {
    id: 45,
    img: "https://api.pizzahut.io/v1/content/en-in/in-1/images/pizza/only-cheesy-pan-personal.951dbe6ee07dafc48e04fe9a1bbe4ddb.1.jpg?width=550",
    name: "Only Cheesy",
    price: 402,
    desc: "Pizza topped with cheesy dressing and mozzarella cheese for that extraaa cheesy flavor.",
    category: "Pizza",
    rating: 5,
  },
  {
    id: 46,
    img: "https://api.pizzahut.io/v1/content/en-in/in-1/images/pizza/classic-sausage-pan-personal.fbbfbce57f62a8d8b366db5f66798704.1.jpg?width=550",
    name: "Classic Sausage",
    price: 238,
    desc: "Pizza topped with our Classic Pan sauce, flavorful chicken sausage and cheesy dressing.",
    category: "Pizza",
    rating: 4,
  },
  {
    id: 47,
    img: "https://api.pizzahut.io/v1/content/en-in/in-1/images/pizza/classic-paneer-capsicum-&-onion-pan-personal.ae2c5f3e3e5881af1f31e65cb9526289.1.jpg?width=550",
    name: "Classic Paneer Capsicum & Onion",
    price: 356,
    desc: "Pizza topped with our Classic Pan sauce, flavorful paneer, crunchy onion & capsicum and cheesy dressing.",
    category: "Pizza",
    rating: 3.9,
  },
  {
    id: 48,
    img: "https://api.pizzahut.io/v1/content/en-in/in-1/images/pizza/italian-pepperoni-&-onion-pan-personal.b6c0c99c9241f2fce14493773f625dd3.1.jpg?width=550",
    name: "Italian Pepperoni & Onion",
    price: 512,
    desc: "Pizza topped with our Chef's Special Italian sauce, crunchy onion, chicken pepperoni and cheesy dressing.",
    category: "Pizza",
    rating: 4.2,
  },
  {
    id: 49,
    img: "https://api.pizzahut.io/v1/content/en-in/in-1/images/pizza/schezwan-meatball-&-capsicum-pan-personal.e27dd4520db7e81fbebeec8428a925bf.1.jpg?width=550",
    name: "Schezwan Meatball & Capsicum",
    price: 190,
    desc: "Pizza topped with Spicy Schezwan sauce, crunchy capsicum, Schezwan meatballs and cheesy dressing making it spice lovers paradise.",
    category: "Pizza",
    rating: 4.0,
  },
  {
    id: 50,
    img: "https://api.pizzahut.io/v1/content/en-in/in-1/images/pizza/tandoori-tikka-&-onion-pan-personal.e47a58535b3ef920e00d559d79defad4.1.jpg?width=550",
    name: "Tandoori Tikka & Onion",
    price: 345,
    desc: "Pizza topped with our signature tandoori sauce, crunchy onion, flavorful chicken tikka and cheesy dressing.",
    category: "Pizza",
    rating: 3.0,
  },
  {
    id: 51,
    img: "https://api.pizzahut.io/v1/content/en-in/in-1/images/pizza/classic-loaded-chicken-delight-pan-personal.8d0b6cb6bc34a734679ac40004edba10.1.jpg?width=550",
    name: "Classic Loaded Chicken Delight",
    price: 429,
    desc: "Pizza topped with our Classic Pan sauce, herbed chicken, flavorful sausages, juicy tomato and cheesy dressing.",
    category: "Pizza",
    rating: 3.9,
  },
];
export default FoodData;
